// Traduit en français les messages d'erreur techniques (Supabase, Edge Functions, réseau).
// Utilisé pour tous les toast.error du CRM afin d'éviter d'afficher de l'anglais brut.
export function translateError(message: string | undefined | null): string {
  if (!message) return 'Une erreur est survenue. Réessayez.';
  const m = String(message).toLowerCase();

  // Edge functions
  if (m.includes('edge function returned a non-2xx') || m.includes('non-2xx status code'))
    return 'La fonction serveur a renvoyé une erreur. Réessayez ou contactez le support.';
  if (m.includes('failedtosendrequest') || m.includes('failed to send request'))
    return 'Impossible de joindre le serveur. Vérifiez votre connexion.';
  if (m.includes('functionsfetcherror') || m.includes('functionshttperror'))
    return 'Erreur de la fonction serveur. Réessayez.';

  // Auth / utilisateurs
  if (m.includes('user not found')) return 'Utilisateur introuvable (peut-être déjà supprimé).';
  if (m.includes('user from sub claim in jwt does not exist'))
    return 'Session expirée ou compte modifié. Reconnectez-vous.';
  if (m.includes('invalid login credentials')) return 'Identifiants invalides.';
  if (m.includes('email not confirmed')) return 'Email non confirmé.';
  if (m.includes('jwt expired') || m.includes('token has expired')) return 'Session expirée. Reconnectez-vous.';
  if (m.includes('invalid jwt') || m.includes('invalid token')) return 'Session invalide. Reconnectez-vous.';
  if (m.includes('not authorized') || m.includes('unauthorized')) return 'Accès non autorisé.';
  if (m.includes('forbidden')) return 'Action interdite.';
  if (m.includes('signups not allowed') || m.includes('signup disabled'))
    return 'Inscriptions désactivées. Contactez l’administrateur.';
  if (m.includes('email rate limit') || m.includes('rate limit'))
    return 'Trop de tentatives. Patientez quelques minutes.';
  if (m.includes('email already registered') || m.includes('already registered'))
    return 'Un compte existe déjà pour cet email.';

  // Mot de passe
  if (m.includes('new password should be different') || m.includes('same as the old password'))
    return 'Le nouveau mot de passe doit être différent de l’ancien.';
  if (m.includes('password should be at least')) return 'Mot de passe trop court (8 caractères minimum).';
  if (m.includes('weak password') || m.includes('password is too weak'))
    return 'Mot de passe trop faible.';
  if (m.includes('pwned') || m.includes('compromised'))
    return 'Ce mot de passe figure dans une fuite de données. Choisissez-en un autre.';

  // Postgres / RLS
  if (m.includes('row-level security') || m.includes('row level security') || m.includes('rls'))
    return 'Vous n’avez pas les droits pour effectuer cette action.';
  if (m.includes('duplicate key') || m.includes('already exists')) return 'Cet enregistrement existe déjà.';
  if (m.includes('violates foreign key')) return 'Impossible : cet élément est encore référencé ailleurs.';
  if (m.includes('violates not-null') || m.includes('null value in column'))
    return 'Champ obligatoire manquant.';
  if (m.includes('permission denied')) return 'Permission refusée.';

  // Réseau
  if (m.includes('failed to fetch') || m.includes('networkerror') || m.includes('network error'))
    return 'Problème de connexion. Vérifiez votre réseau.';
  if (m.includes('timeout')) return 'Délai dépassé. Réessayez.';
  if (m.includes('500') || m.includes('internal server error')) return 'Erreur serveur. Réessayez dans un instant.';
  if (m.includes('404') || m.includes('not found')) return 'Ressource introuvable.';
  if (m.includes('400') || m.includes('bad request')) return 'Requête invalide.';

  // Stockage
  if (m.includes('payload too large') || m.includes('too large')) return 'Fichier trop volumineux.';
  if (m.includes('mime type')) return 'Type de fichier non autorisé.';

  return message;
}
